import { FilterType } from '@core/models';

export interface AdvancedFilterData {
  id: number;
  name: string;
  display: boolean;
  parentId?: number;
  count?: number;
  active: boolean;
  disabled?: boolean;
  children?: AdvancedFilterData[];
}

export interface AdvancedFilterRangeData {
  min: number,
  max: number,
}

export interface ActiveFilterData extends AdvancedFilterData {
  type: string;
}

export enum FilterTypeRanges {
  PRICE = 'priceRanges',
  YEAR = 'yearRanges',
}

export type AvailableFilters = Record<FilterType | string, AdvancedFilterData[]> & {
  priceRanges?: AdvancedFilterRangeData,
  yearRanges?: AdvancedFilterRangeData,
  yearFrom?: number,
  yearTo?: number,
  priceFrom?: number,
  priceTo?: number,
};
export type ActiveFilters = Record<FilterType | string, number[]> & {
  availability?: number | number[],
  searchTerm?: string
  extendedSearch?: boolean
  yearFrom?: number,
  yearTo?: number,
  yearEnd?: number,
  priceFrom?: number,
  priceTo?: number,
  priceEnd?: number,
};

export enum UpdateAvailableFiltersReason {
  initialization = 'initialization',
  userAction = 'user-action',
  systemUpdate = 'system-update',
}

export interface UpdateAvailableFilters {
  data: AvailableFilters;
  dataForQueryCount: AvailableFilters;
  searchTerm: string;
  extendedSearch: boolean;
  reason: UpdateAvailableFiltersReason;
  _allCount?: number | null;
}

export interface SetFiltersParams {
  filters?: AvailableFilters;
  searchTerm?: string;
  extendedSearch?: boolean;
  _allCount?: number | null;
}

export interface SearchValue {
  searchTerm: string;
  extendedSearch: boolean;
}
